import api from "../infrastructure/Api";

export const GetImage = async (fileName) => {
    return await api.getImage({fileName});
}